import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "container" }


import { Action } from '@/components/TableComponent/types';
import { storeToRefs } from 'pinia';
import { computed, defineComponent, ref } from 'vue';
import { useContractsStore } from '~store/contracts/contractsModule';
import TableComponent from '@/components/TableComponent/TableComponent.vue';
import TabsWrapper from '@/components/tabs/TabsWrapper.vue';
import { actionHandler } from '@/actions/actionHandler';
import { SubdoerPrice } from '@/store/contracts/types';

const __default__ = defineComponent({
  name: 'ContractsView',
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  async setup(__props) {

let __temp: any, __restore: any

const splitterModel = ref(50);
const contractsStore = useContractsStore();

const { contracts } = storeToRefs(contractsStore);

if (!contracts.value.data) {
  (
  ([__temp,__restore] = _withAsyncContext(() => useContractsStore().loadContracts())),
  await __temp,
  __restore()
);
}

const openEditor = () => {
  const action: Action = {
    type: 'modal',
    name: 'EditContractModal',
    customParam: {
      maximized: true,
    },
  };
  actionHandler(action);
};

const { currentSubdoer, selectedServices } = storeToRefs(contractsStore);

const showBindingButton = computed(() => currentSubdoer.value && selectedServices.value.length);
const bindingStatus = computed(() => {
  if (!selectedServices.value.length || !currentSubdoer.value) {
    return false;
  }
  const firstService = selectedServices.value[0];
  let subdoersData: number[] = [];
  try {
    subdoersData = JSON
      .parse(firstService.prices_sub_doer_json)
      .map((el: SubdoerPrice) => el.id_contract_sub_doer);
  } catch (error) {
    console.log(error);
  }
  if (firstService.binded && subdoersData.includes(currentSubdoer.value.id_contract_sub_doer)) {
    return true;
  }
  return false;
});

const handleSubdoers = () => {
  contractsStore.bindSubdoers();
};


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_splitter = _resolveComponent("q-splitter")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_splitter, {
      modelValue: splitterModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((splitterModel).value = $event)),
      style: {"height":"100%","width":"100%"}
    }, {
      before: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_unref(contracts).data)
            ? (_openBlock(), _createBlock(TableComponent, {
                key: 0,
                tableId: "contracts-table",
                table: _unref(contracts)
              }, null, 8, ["table"]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_btn, {
            fab: "",
            class: "fab fab_bottom-right",
            icon: "add",
            color: "accent",
            onClick: openEditor
          })
        ])
      ]),
      after: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TabsWrapper)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(showBindingButton))
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          class: "fab fab_centered",
          fab: "",
          icon: !_unref(bindingStatus) ? 'link' : 'link_off',
          color: "accent",
          style: _normalizeStyle(`left: ${splitterModel.value}%`),
          onClick: handleSubdoers
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(!_unref(bindingStatus) ? 'Связать' : 'Отвязать'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["icon", "style"]))
      : _createCommentVNode("", true)
  ]))
}
}

})